import httpService from '@/services/core/http.service';

class SessionService {
    tokenKey = 'admin-portal-token';

    constructor() {
        window.addEventListener(
            'storage',
            evt => {
                if (evt.key == this.tokenKey && evt.newValue == null) window.location.reload();
            },
            false
        );
    }

    setToken = token => localStorage.setItem(this.tokenKey, `Bearer ${token}`);
    removeToken = () => localStorage.removeItem(this.tokenKey);
    getToken = () => localStorage.getItem(this.tokenKey);

    login = redirectUrl => httpService.get(`/auth/login`, { redirectUrl }, { customCatch: true });
    varifySession = sessionId => httpService.get(`/auth/verify/${sessionId}`);
    logout = () => httpService.get(`/auth/logout`);
}

export default new SessionService();
